export default __webpack_public_path__ + "static/media/menuArrowDown.4e825ed6.svg";